import { render, staticRenderFns } from "./Pos.vue?vue&type=template&id=1cd112be&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=ts"
export * from "./Pos.vue?vue&type=script&lang=ts"
import style0 from "./Pos.vue?vue&type=style&index=0&id=1cd112be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd112be",
  null
  
)

export default component.exports